'use client'

import { useGetCityQuery } from '@/api/cities/get-city-query'
import { T } from '@/components/t'

interface IRestaurantCitySeoDescriptionProps {
    citySlug: string
    className?: string
}

export const RestaurantCitySeoDescription = ({
    citySlug,
    className,
}: IRestaurantCitySeoDescriptionProps) => {
    const { data } = useGetCityQuery(citySlug)

    return (
        <T
            t={['restaurants.city.description', { cityName: data?.data.name ?? '' }]}
            className={className}
        />
    )
}
